module.exports = __webpack_public_path__ + "img/time-off.8038cf97.png";